import { FacebookIcon, InstagramIcon, LinkedIcon, TwitterIcon } from "Website/assets/images";
import appstore from 'Website/assets/images/appstore.png';
import googleplay from 'Website/assets/images/googleplay.png';
import SelectLanguage from 'Website/Language/Components/SelectLanguage';
import Menu from 'Website/Menu/Components/Menu';
import Logo from "./Logo";
import { useTranslation } from "react-i18next";


const Footer = (props) => {
    const { t } = useTranslation();

    return (
        <footer>
            <Logo />
            <div className='footer_nav_block'>
                <Menu displayMenu={['AboutMenu', 'PrivacyMenu', 'TermsMenu', 'ContactUsMenu', 'DazWayWebMenu', 'HelpMenu']} />
                {/* <Menu displayMenu={['AboutMenu', 'PrivacyMenu', 'TermsMenu', 'ContactUsMenu', 'DazWayWebMenu', 'HelpMenu','PolicyMenu']} /> */}

                <div>
                    <p>{t("footer.copyright")}</p>
                    {/* <SelectLanguage handleSetLanguage={props.handleSetLanguage} selectedLang={props.selectedLang} /> */}
                </div>
            </div>
            <div className="social_block">
                <div>
                    <a href={process.env.REACT_APP_IOS_APP_URL} target="_blank" rel="noreferrer"><img src={appstore} alt="App Store" title="App Store" className="lazy-img" /></a>
                    <a href={process.env.REACT_APP_ANDROID_APP_URL} target="_blank" rel="noreferrer"><img src={googleplay} alt="Google Play" title="Google Play" className="lazy-img" /></a>
                </div>
                <div>
                    <a href={process.env.REACT_APP_SOCIAL_APP_URL} target="_blank" rel="noreferrer"><FacebookIcon /></a>
                    <a href={process.env.REACT_APP_SOCIAL_APP_URL} target="_blank" rel="noreferrer"><TwitterIcon /></a>
                    <a href={process.env.REACT_APP_SOCIAL_APP_URL} target="_blank" rel="noreferrer"><LinkedIcon /></a>
                    <a href={process.env.REACT_APP_SOCIAL_APP_URL} target="_blank" rel="noreferrer"><InstagramIcon /></a>
                </div>
            </div>
        </footer>
    )
}

export default Footer;